import { useAppDispatch, useAppSelector } from '@hooks/reduxHooks'
import { Save } from '@mui/icons-material'
import { Button, Divider } from '@mui/material'
import { doGetCouverture } from '@state/thunks/patientsThunk'
import React, { useEffect, useState } from 'react'
import CouvertureDisplay from '../../containers/app/billing/form/PatientCouvertureData'
import RegisterPatientForm from '../../containers/app/billing/form/RegisterPatientForm'
import { PatientDisplay } from './PatientInfos'
import { EditIcon } from 'lucide-react'

type Props = {
  patientId: number
  visitId?: number
  containerClassName?: string
  onClose?: () => void
}

const PatientDataContainer: React.FC<Props> = ({
  patientId,
  visitId,
  onClose,
}) => {
  const dispatch = useAppDispatch()
  const [isEditMode, setisEditMode] = useState(false)

  const { patient, coverage } = useAppSelector(({ patients }) => ({
    patient: patients.currentPatientInfo,
    coverage: patients.patientCouverture,
  }))

  useEffect(() => {
    dispatch(
      doGetCouverture({
        idVisit: visitId,
        idPatient: patientId,
      }),
    )
      .unwrap()
      .then((res) => {
        if (!res) {
          dispatch(
            doGetCouverture({
              idPatient: patientId,
            }),
          )
        }
      })
  }, [visitId, patientId])

  return (
    <div>
      <div className="flex justify-end gap-4 sticky top-0 p-3 bg-white z-10">
        <Button
          variant="contained"
          color={isEditMode ? 'info' : 'secondary'}
          onClick={() => setisEditMode(!isEditMode)}
          startIcon={isEditMode ? <Save /> : <EditIcon />}
        >
          {isEditMode ? 'Terminer' : 'Modifier'}
        </Button>

        <Button aria-label="close" variant="outlined" onClick={onClose}>
          Fermer
        </Button>
      </div>
      <Divider sx={{ my: 2 }} />
      {isEditMode ? (
        <RegisterPatientForm
          isOpen={isEditMode}
          onClose={() => setisEditMode(false)}
          mode="div"
        />
      ) : (
        <>
          <PatientDisplay patientId={patientId} />
          {patient && (
            <CouvertureDisplay
              couverture={
                coverage ||
                ({
                  id: 1,
                  beneficiaireNom: '',
                  beneficiairePrenom: '',
                  beneficiaireNir: '',
                  beneficiaireDateNaissance: '',
                  beneficaireNomUsuel: '',
                  assureNom: '',
                  assureNomUsuel: '',
                  assurePrenom: '',
                  assureNir: '',
                  rangNaissance: 1,
                  qualite: 1,
                  idOrganismeAmo: 1,
                  nomDomaineAmc: '',
                  dateFinAmc: '',
                  dateDebutAmc: '',
                  dateFinAmo: '',
                  dateDebutAmo: '',
                  codeSituationAmo: '',
                  idOrganismeAmc: 1,
                  idPatient: 1,
                  idMedicalOrder: 1,
                  identifiantHoteAmc: '',
                } as any)
              }
            />
          )}
        </>
      )}
    </div>
  )
}

export default PatientDataContainer
